import React, { useState } from "react";
import Modal from "./Modal";
import ModalUploadProcess from "./ModalUploadProcess";
import { DashboardContext } from "contexts/DashboardContext";
import { Dropzone } from "components/forms/Dropzone";
import { DropzoneFileList } from "components/forms/DropzoneFileList";
import { Code, PhotoBoothSession } from "@mijnfotohoek-types";
import firebase from "../../firebase";
import axios from "axios";
import { FaExclamation } from "react-icons/fa";

const ModalPhotoBoothSessionUpload = ({
  close,
  photoBoothSession,
  codes,
}: {
  close: () => void;
  photoBoothSession: PhotoBoothSession;
  codes: Code[];
}) => {
  const [files, setFiles] = React.useState([]);
  const [uploading, setUploading] = React.useState(false);
  const [uploadingProgress, setUploadingProgress] = React.useState(0);
  const { firebaseBaseUrl, sendToast } = React.useContext(DashboardContext);

  const upload = async () => {
    setUploading(true);
    setUploadingProgress(0);
    let error = false;
    const token = await firebase.auth().currentUser.getIdToken(true);
    for (let i = 0; i < files.length; i++) {
      setUploadingProgress(i + 1);
      try {
        // make request to upload endpoint; returns corresponding firestore documents
        await axios({
          url: `${firebaseBaseUrl}uploadToCode`,
          data: files[i],
          method: "post",
          params: {
            codes: `[${codes.map((c) => `"${c.id}"`).join(",")}]`,
            fileName: files[i].name,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (err) {
        error = true;
        // internal server error
        sendToast(
          `${files[i].name} niet geüpload`,
          `Dit bestand is niet geüpload door een server fout`,
          "error",
          null,
        );
      }
    }
    if (!error)
      sendToast(
        "Gelukt",
        `Foto${files.length === 1 ? ` is` : `'s zijn`} geüpload`,
        "success",
      );
    setUploading(false);
    setUploadingProgress(0);
    close();
  };

  return (
    <Modal title="Handmatig foto's uploaden" width={600} close={close}>
      <div className="text-red-500 border-2 border-solid border-red-300 p-4 rounded-xl mt-8">
        <span className="font-bold">Let op</span>: de foto's die je hier upload,
        worden aan alle QR-codes toegevoegd in de fotohoek{" "}
        <b>"{photoBoothSession.title}"</b>
      </div>

      {uploading && (
        <ModalUploadProcess
          files={files}
          uploadingProgress={uploadingProgress}
        />
      )}
      <div className="flex flex-col gap-8 mt-8">
        <Dropzone files={files} setFiles={setFiles} />
        {files.length > 0 && (
          <DropzoneFileList
            files={files}
            setFiles={setFiles}
            upload={upload}
            uploading={uploading}
          />
        )}
      </div>
    </Modal>
  );
};

export default ModalPhotoBoothSessionUpload;
